import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchCallScheduledReportTableAndFilterSchema } from "model/CallScheduledReportModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const CallScheduledReportContext = createContext();

export const CallScheduledReportProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [callScheduledReportContextData, setCallScheduledReportContextData] = useState();

    const fetchCallScheduledReportContextData = async () => {
        setLoading(true);
        try {
            const response = await fetchMetadataSchema("metadata:callScheduledReport", () =>
                fetchCallScheduledReportTableAndFilterSchema([])
            );
            if (response?.success) {
                setCallScheduledReportContextData(response?.data);
            }
        } catch (err) {
            toast.error(err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <CallScheduledReportContext.Provider
            value={{
                fetchCallScheduledReportContextData,
                callScheduledReportContextData,
                loading,
                error,
            }}
        >
            {children}
        </CallScheduledReportContext.Provider>
    );
};

export const useCallScheduledReportContext = () => useContext(CallScheduledReportContext);
